<template>
  <div class="challenge-end-date" v-if="challenge.endDate && moment(challenge.endDate).isAfter(moment.now())">
    <div class="challenge-time">
      <h1>{{ getChallengeTimeDifferenceValue(challenge.endDate, 'days') }}</h1>
      {{ $t('countdown_full_days') }}
    </div>
    <div class="challenge-time">
      <h1>{{ getChallengeTimeDifferenceValue(challenge.endDate, 'hours') }}</h1>
      {{ $t('countdown_full_hours') }}
    </div>
    <div class="challenge-time">
      <h1>{{ getChallengeTimeDifferenceValue(challenge.endDate, 'minutes') }}</h1>
      {{ $t('countdown_full_minutes') }}
    </div>
  </div>
  <div v-else-if="moment(challenge.endDate).isBefore(moment.now())" class="challenge-end-date-expired">
    <h3>Expired</h3>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { getChallengeTimeDifferenceValue } from '../../util/date'
  import moment from 'moment'

  export default defineComponent({
    name: "ChallengeCountdown",
    computed: {
      moment() {
        return moment
      }
    },
    methods: { getChallengeTimeDifferenceValue },
    props: {
      challenge: {
        type: Object,
        required: true,
      }
    }
  })

</script>
<style scoped lang="scss">
  .challenge-end-date {
    display: flex;
    width: 80%;
    justify-content: space-between;
    margin: 0 auto;
    flex-direction: row;

    .challenge-time {
      display: flex;
      flex-direction: column;
      text-align: center;
    }
  }

  .challenge-end-date-expired {
    text-align: center;
  }
</style>
